import { useEffect, useState } from "react";
import { ImageInfo } from "../../common/Common";
import styles from "./StoryPictureGrid.module.css";
import ImageModal from "./ImageModal";
import { ImageOptions } from "./GridGallery";


interface StoryPictureGridProps {
    images: ImageInfo[];
    storyType?: string;
}


const StoryPictureGrid = (props : StoryPictureGridProps) => {

    const [showImgModal, setShowImgModal] = useState(false);
    const [selectedImg, setSelectedImg] = useState(0);
    const [imageData, setImageData] = useState<ImageOptions[]>();

    useEffect(()=>{
        const newArr = props.images.map(obj =>({
            url: obj.src as string,
            IID: obj.id as number,
        }))
        setImageData(newArr);
    },[])

    const onClickImage = (idx: number) => {
        setShowImgModal(true);
        setSelectedImg(idx);
    }

    const renderItem = () => {

        if (props.storyType && props.storyType !== 'story') {
            return (
                <div className={styles.container}>
                    <div
                        className={styles.soloImage}
                    >
                        <img src={props.images[0].src as string}/>
                    </div>
                </div>
            )
        }


        if (props.images.length == 1) {
            return (
                <div className={styles.container}>
                    <div
                        className={styles.soloImage}
                        onClick={()=>onClickImage(0)}
                    >
                        <img src={props.images[0].src as string}/>
                    </div>
                </div>
            )
        }
        else if (props.images.length == 2) {
            return (
                <div className={styles.container}>
                    <div 
                        className={styles.left}
                        onClick={()=>onClickImage(0)}
                    >
                        <img src={props.images[0].src as string}/>
                    </div>
                    <div 
                        className={styles.right}
                        onClick={()=>onClickImage(1)}
                    >
                        <img src={props.images[1].src as string}/>
                    </div>
                </div>
            )
        }
        // 3개 이상일 떄
        else if (props.images.length >= 3) {
            return (
                <div className={styles.container}>
                    <div 
                        className={styles.left}
                        onClick={()=>onClickImage(0)}
                    >
                        <img src={props.images[0].src as string}/>
                    </div>
                    <div className={styles.right}> 
                        <div className={styles.rightup} onClick={()=>onClickImage(1)}>
                            <img src={props.images[1].src as string}/>
                        </div>
                        <div 
                            className={styles.moreImage} 
                            onClick={()=>onClickImage(2)}
                        >
                            <img src={props.images[2].src as string} />
                            <p>{props.images.length-2}개 더보기</p>
                        </div>
                    </div>
                </div>
            )
        }
    }

        return (
            <>
                {renderItem()}
                {imageData && <ImageModal
                showModal={showImgModal}
                setShowModal={setShowImgModal}
                images={imageData}
                selected={selectedImg}
                setSelected={setSelectedImg}
                />}
            </>
        )

};

export default StoryPictureGrid;